export default __webpack_public_path__ + "dist/media/Eye.15f6822d.svg";